const getBroswerLangs = (): string[] => navigator.languages.map((lang) => lang);
const getBrowserLang = (): string => getBroswerLangs() ? getBroswerLangs()[0] : 'en-US';

export const I18nService = {
	getBrowserLang,
	getBroswerLangs
}